import cn from 'classnames';
import { memo, useLayoutEffect } from 'react';
import { useDescriptionEditor } from '@widgets/shared/descriptionEditor/model.ts';
import { useDescriptionEditorValueHandler } from '@widgets/shared/Forms/DescriptionEditor/useDescriptionValueHandler.ts';
import type { EditorType } from '@widgets/shared/Forms/EditorTypes.ts';
import { FormFieldWithLabelAndCard } from '@shared/ui/forms/FieldWithLabel/index';
import { ViewerNoteEditorContent } from '@shared/ui/index.ts';
import * as st from './styles.module.scss';

type PT = EditorType<string> & {
  hash: string;
  fieldLabel?: string;
  descriptionPageTitle?: string;
  contentClassName?: string;
  whereUse?: 'inModal';
  onClickReplacement?: () => void;
};
export const FormDescriptionEditor = memo(
  ({
    onRedirect,
    contentClassName,
    initData,
    onChange,
    hash,
    whereUse,
    fieldLabel = 'Описание',
    error,
    descriptionPageTitle,
  }: PT) => {
    const { value, setValue, redirectToDescriptionEditorPage } = useDescriptionEditor(hash);

    const { isImgGoingAfterText, isImgFirst } = useDescriptionEditorValueHandler({ value });

    useLayoutEffect(() => {
      initData && value === '' && setValue(initData);
    }, [initData]);

    useLayoutEffect(() => {
      onChange && value !== '' && onChange(value);
    }, [onChange, value]);

    const onEditorFieldClick = () => {
      onRedirect && onRedirect();
      redirectToDescriptionEditorPage(descriptionPageTitle);
    };

    return (
      <FormFieldWithLabelAndCard
        fieldLabel={whereUse === 'inModal' ? undefined : fieldLabel}
        withRedirectArrow
        onClick={onEditorFieldClick}
        className={cn(st.field, error && st.error, whereUse && st[whereUse])}
      >
        <ViewerNoteEditorContent
          className={cn(
            isImgGoingAfterText && st.imgGoingAfterText,
            isImgFirst && st.imgFirst,
            contentClassName
          )}
          htmlString={value}
          type={'formField'}
        />
        {whereUse === 'inModal' && !value && <p className={st.placeholder}>{fieldLabel}</p>}
      </FormFieldWithLabelAndCard>
    );
  }
);
